export default "__VITE_ASSET__DpwvRObt__"